module.exports = __webpack_public_path__ + "static/media/xtrapc-logo.c062b854.png";